<template>
    <div class="input-wrapper password-icons" v-if="settings.show">
        <div class="password-icon-row" v-for="item in signUp.passwordValidation.items"
                                        :class="{dark: settings.dark}">
            <div class="input-icon"><i v-bind:class="item.iconClass"></i></div>
            <div>{{item.name}}</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "passwordValidation",

        data() {
            return {
                inputValue: this.settings.validation,
                signUp: {
                    passwordValidation: {
                        show: false,
                        items: {
                            length: {
                                name: this.translate('password_validation_min_length'),
                                value: false,
                                iconClass: 'fas fa-check-circle icon-inactive',
                                isValid: function (item) {
                                    return item.length >= 6
                                }
                            },
                            uppercase: {
                                name: this.translate('password_validation_uppercase'),
                                value: false,
                                iconClass: 'fas fa-check-circle icon-inactive',
                                isValid: function (item) {
                                    return item.match(/[A-Z]|[А-Я]/g) !== null
                                }
                            },
                            lowercase: {
                                name: this.translate('password_validation_lowercase'),
                                value: false,
                                iconClass: 'fas fa-check-circle icon-inactive',
                                isValid: function (item) {
                                    return item.match(/[a-z]|[а-я]/g) !== null
                                }
                            },

                        }
                    }
                },
            }
        },
        props: {
            settings: {
                type: [Object, null],
                default: () => {
                    return {}
                }
            },
        },
        watch: {
            'settings.validation'(item) {
                for (var valKey in this.signUp.passwordValidation.items) {
                    let valItem = this.signUp.passwordValidation.items[valKey]
                    valItem.value = valItem.isValid(item)
                    valItem.iconClass = valItem.value ? 'fas fa-check-circle icon-active' : 'fas fa-check-circle icon-inactive'
                }
            },
        },
    }
</script>

<style scoped>
    .password-icons {
        margin-top: -20px;
        margin-left: 25px;
        flex-direction: column;
    }

    .password-icon-row .input-icon {
        margin-top: 0;
        padding-right: 5px;
    }

    .password-icon-row {
        display: flex;
        color: #e5e5e5;
        font-weight: 700;
        font-size: 16px;
        line-height: 22px;
        font-family: 'Nunito';
    }
    .password-icon-row.dark {
        color: #3F405C;
    }

    .password-icon-row .icon-active {
        color: #36BC00;
    }

    .password-icon-row .icon-inactive {
        color: #FD4315;
    }
</style>